import type { FC } from 'react';
import type { Match, WrestlerInMatch } from '../../../types';
import { BoxWhenFatalorTagMatchContainer, DefaultContainerCard, RowOpponentWhenTwoWrestlerInBox, TopDecorColor } from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender, { AvatarWrestlerWhenThreeOrFourWrestlerInMatch } from './GenericComponentMatchCard';

interface TagMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const TagMatchCard: FC<TagMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
    return (
        <DefaultContainerCard>
            <TopDecorColor />

            <BoxWhenFatalorTagMatchContainer className="box-team-container-left">

                <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-left">
                    <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                        wrestler={matchInfo.wrestlers_by_team![0][0]}
                        win_by_dq={matchInfo.win_by_dq}
                        navigateToWrestler={navigateToWrestler}
                    />
                    <h6 className="opponent-name">{matchInfo.wrestlers_by_team![0][0].name}</h6>
                </RowOpponentWhenTwoWrestlerInBox>

                <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-left">
                    <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                        wrestler={matchInfo.wrestlers_by_team![0][1]}
                        win_by_dq={matchInfo.win_by_dq}
                        navigateToWrestler={navigateToWrestler}
                    />
                    <h6 className="opponent-name">{matchInfo.wrestlers_by_team![0][1].name}</h6>
                </RowOpponentWhenTwoWrestlerInBox>

            </BoxWhenFatalorTagMatchContainer>

            <CenterInfoFightComponentRender nameMatch="Tag Team" matchInfo={matchInfo} />

            <BoxWhenFatalorTagMatchContainer className="box-team-container-right">

                <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-right">
                    <h6 className="opponent-name">{matchInfo.wrestlers_by_team![1][0].name}</h6>
                    <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                        wrestler={matchInfo.wrestlers_by_team![1][0]}
                        win_by_dq={matchInfo.win_by_dq}
                        navigateToWrestler={navigateToWrestler}
                    />
                </RowOpponentWhenTwoWrestlerInBox>

                <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-right">
                    <h6 className="opponent-name">{matchInfo.wrestlers_by_team![1][1].name}</h6>
                    <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                        wrestler={matchInfo.wrestlers_by_team![1][1]}
                        win_by_dq={matchInfo.win_by_dq}
                        navigateToWrestler={navigateToWrestler}
                    />
                </RowOpponentWhenTwoWrestlerInBox>

            </BoxWhenFatalorTagMatchContainer>

        </DefaultContainerCard>
    );
};

export default TagMatchCard;
